import React, { useRef } from "react";
import { Box, TextField } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "../alerts/InfoMessage.js";
import "../alerts/NoAccessInfoMessage.js";
import { Message, MessageOrientation, MessageType } from "../alerts/Message.js";
import "react-intl";
import "../alerts/InfoAlert.js";
import "../alerts/InfoMessageHoc.js";
import { withEditButton } from "./EditButtonHoc.js";
import { dashCharacter } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
const useClasses = makeStyles()((theme) => ({
  editableTextContainer: {
    display: "flex",
    alignItems: "center",
    width: "100%"
  },
  editableTextInput: {
    width: "100%",
    background: "transparent",
    "& > .Mui-disabled": {
      color: "inherit"
    },
    "& .MuiInputBase-input": {
      textOverflow: "ellipsis"
    }
  },
  editableTextErrorMessage: {
    ...theme.typography.caption,
    padding: theme.spacing(0.5),
    whiteSpace: "normal"
  },
  editableTextReadonly: {
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}));
const EditableTextInternal = ({
  mode,
  errorMessageOrientation = MessageOrientation.Inline,
  errorMessage,
  formatter,
  onEnterPress,
  ...props
}) => {
  const { classes } = useClasses();
  const containerRef = useRef(null);
  const { disabled, value, placeholder } = props;
  const isEditDisabled = disabled || mode !== "Edit";
  const inputValue = isEditDisabled && !value ? dashCharacter : value;
  const disabledInputValue = isEditDisabled && !value ? dashCharacter : formatter ? formatter(value) : value;
  const inputPlaceholder = mode === "Edit" ? placeholder : inputValue;
  return isEditDisabled ? /* @__PURE__ */ React.createElement(Box, { className: classes.editableTextReadonly }, disabledInputValue) : /* @__PURE__ */ React.createElement("div", { ref: containerRef, className: classes.editableTextContainer }, /* @__PURE__ */ React.createElement(
    TextField,
    {
      ...props,
      inputProps: { "data-testid": "editableTextInput" },
      className: classes.editableTextInput,
      value: inputValue,
      disabled: isEditDisabled,
      variant: mode !== "Edit" ? "standard" : "outlined",
      placeholder: inputPlaceholder,
      onKeyDown: (e) => {
        if (["Enter", "NumpadEnter"].includes(e.code) && onEnterPress) {
          e.preventDefault();
          onEnterPress(inputValue);
          e.stopPropagation();
        }
      }
    }
  ), /* @__PURE__ */ React.createElement(
    Message,
    {
      containerRef,
      className: classes.editableTextErrorMessage,
      message: errorMessage,
      variant: "inherit",
      messageType: MessageType.Error,
      messageOrientation: errorMessageOrientation
    }
  ));
};
const EditableText = withEditButton(EditableTextInternal);
export {
  EditableText,
  EditableTextInternal
};
//# sourceMappingURL=EditableText.js.map
